<h1>Editace dokumentu</h1>
<fieldset>
  <div class="column-100">
    <label class="required">Název</label>
    <input class="info" type="text" [(ngModel)]="attachment.baseName"/>
    <label class="required" *ngIf="allowType">Typ</label>
    <div *ngIf="allowType" class="info">
      <div class="checklist">
        <div class="checklist-item" *ngFor="let attachmentType of attachmentTypes" (click)="(!attachmentType.disabled || attachmentType.id === initialAttachmentType.id) && onUpdateType(attachmentType)">
          <gmt-radio [gmtChecked]="attachmentType.id === activeAttachmentType.id" [gmtDisabled]="!!attachmentType.disabled && attachmentType.id !== initialAttachmentType.id"></gmt-radio>
          <span [ngClass]="{ disabled: !!attachmentType.disabled  && attachmentType.id !== initialAttachmentType.id}">
            <i [ngClass]="['ml-10 mr-5 fa ' + attachmentType.icon]"></i>
            {{ attachmentType.title }}
            <span *ngIf="attachmentType.extensions">(<span class="comma-list"><span *ngFor="let extension of attachmentType.extensions">{{extension}}</span></span>)</span>
          </span>
          <span *ngIf="!!attachmentType.disabled && attachmentType.id !== initialAttachmentType.id" class="error-message"> ({{ attachmentType.disabled }})</span>
        </div>
      </div>
    </div>
    <label>Poznámka k dokumentu</label>
    <textarea [(ngModel)]="attachment.note"></textarea>
  </div>
</fieldset>
<div class="text-center pt-20">
  <gmt-button [clickAction]="onUpdate" [gmtDisabled]="!isValid()">Uložit dokument</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Zrušit</gmt-button>
</div>
